/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import BaseCom from "./BaseCom";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { SidebarGlobal } from "./_Sidebar";
import Auth from "../shared/Auth";
import { Pop } from "./PopModal";
import Globals from "../shared/Globals";
import Icon from "./Icon";
import { Modal } from "react-bootstrap";
import FormInput from "./FormInput";
import UploadPad from "./UploadPad";
import Checkout2Modal from "./payment/Checkout2Modal";
import ScrollHandler from "./ScrollHandler";
import L from "./Lang";

export const PurchaseOrderGlobal = {
    getStatus(item, sendFunc) {
        if (!item)
            return;
        return item.completed ? <span className="badge bg-success">Delivered</span>
            : item.canceled ? <span className="badge text-muted opacity-50">Canceled</span>
                : item.shipped ? <span className="badge bg-primary">Shipped</span>
                    : item.onHold ? <span className="badge bg-warning">On Hold</span>
                        : item.readyToShip ? <span className="badge bg-info">Packaged</span>
                            : item.confirmed ? <span className="badge bg-primary">Approved</span>
                                : (item.businessApproved || item.distributionApproved)
                                    ? (Auth.hasRole('manager') ? <>
                                        {item.businessApproved ? <><span className="badge bg-success">BA</span> </> : <><span className="badge bg-secondary">BA Pending</span> </>}
                                        {item.distributionApproved ? <> <span className="badge bg-success">DA</span></> : <> <span className="badge bg-secondary">DA Pending</span></>}
                                    </> : <span className="badge bg-primary">Processing Approval</span>)
                                    /*: !item.sent && sendFunc ? <button type="button" className="btn btn-success" onClick={(e) => sendFunc(item, e)} disabled={item.sending}>
                                        <Icon icon="faPaperPlane" /> Send
                                    </button>*/
                                    : <span className="badge bg-primary">Submitted</span>;
    }
};

// SHIP TRACKING NUMBER MODAL
class ShipTrackingNumber extends BaseCom {

    componentDidMount() {
        this.setState({ trackingNumber: this.props.defaultTrackingNumber });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultTrackingNumber !== this.props.defaultTrackingNumber) {
            this.setState({ trackingNumber: this.props.defaultTrackingNumber });
        }
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Enter Tracking Number</Modal.Title>
                </Modal.Header>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    this.props.onSubmit(this.state.trackingNumber);
                    this.props.onHide();
                }}>
                    <Modal.Body>
                        <div className="form-group">
                            <label className="form-label">* Tracking Number</label>
                            <input type="text"
                                className="form-control"
                                value={this.state.trackingNumber}
                                onChange={e => this.setState({ trackingNumber: e.target.value })}
                                required
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={this.props.onHide}>Close</button>
                        <button type="submit" className="btn btn-primary"><Icon icon="faPlane" /> Ship</button>
                    </Modal.Footer>
                </form>
            </Modal>
        )
    }
}

// DELIVER MODAL
class DeliverModal extends BaseCom {
    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Mark as Delivered</Modal.Title>
                </Modal.Header>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    this.props.onSubmit();
                    this.props.onHide();
                }}>
                    <Modal.Body>
                        <div className="form-group">
                            {this.props.show && <UploadPad
                                item={this.props.currentItem}
                                name="attachments"
                                onUploadBegin={() => this.setState({ uploading: true })}
                                onUploadEnd={() => this.setState({ uploading: false })}
                            />}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={this.props.onHide}>Close</button>
                        <button type="submit" className="btn btn-primary" disabled={this.state.uploading}><Icon icon="faTruck" /> Mark as Delivered</button>
                    </Modal.Footer>
                </form>
            </Modal>
        )
    }
}

// MAIN COMPONENT
class PurchaseOrders extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: [],
            page: 1
        };
    }

    componentDidMount() {
        Auth.getLogin(u => this.setState({ user: u }));
        this.load();

    }

    componentDidUpdate(prevProps) {
        if (prevProps.accountID !== this.props.accountID) {
            this.load();
        }
    }

    componentWillUnmount() {
        if (!this.props.com)
            SidebarGlobal.clearSubNav();
    }

    load = (search, page) => {
        if (!page) page = 1;
        if (search === undefined)
            search = this.state.search;
        this.setState({ loading: true, search: search, page: page });
        let query = { ...this.state.query, search: search, page: page };
        if (this.props.accountID)
            query.parentObjectID = this.props.accountID;
        qreq.post('/api/purchase-order/list', query, j => {
            if (j.list) {
                if (page === 1)
                    this.setState({ list: j.list });
                else {
                    if (j.list.length === 0)
                        this.setState({ end: true });
                    else
                        this.setState({ list: [...this.state.list, ...j.list] });
                }
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true });
            setTimeout(() => this.setState({ loading: false }), 1000);
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    pay = (item, e, callback) => {
        this.setState({ showCheckout: true, checkoutCallback: callback, checkoutItem: item });
    }

    getAccountAsync = async (id) => {
        try {
            let j = await qreq.getAsync('/api/account/get/' + id);
            if (j.item)
                return j.item;
        }
        catch (e) {
            console.error(e);
        }
        return null;
    }

    sendPO = async (item, e) => {
        e?.preventDefault();
        e?.stopPropagation();
        this.setState({ list: this.state.list });
        // dev
        let account = await this.getAccountAsync(item.accountID);
        if (account.isPaymentPortal && !item.isPaid) {
            this.pay(item, e, async () => {
                this.setState({ showCheckout: false, checkoutCallback: null, checkoutItem: null });
                await this.sendPONow(item);
            });
            return;
        }
        // /dev
        Pop.showConfirm(<div>Are you sure you want to send this purchase order?</div>, 'Send Purchase Order', async () => {
            await this.sendPONow(item);
        });
    }

    sendPONow = async (item) => {
        item.sending = true;
        try {
            let j = await qreq.postAsync('/api/purchase-order/send', item);
            if (j.errorCode === 0) {
                item.sent = true;
                this.setState({ list: this.state.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        item.sending = false;
    }

    createInvoice = (item) => {
        Pop.showConfirm(<div>Are you sure you want to create an invoice for this purchase order?</div>, 'Create Invoice', () => {
            qreq.post('/api/purchase-order/create-invoice', { id: item.id }, j => {
                if (j.item) {
                    this.props.navigate('/invoice/edit/' + j.item.id);
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        });
    }

    downloadPDF = (id, iid) => {
        window.open(Globals.serverUrl + '/api/purchase-order/pdf/' + id + '/' + iid + '.pdf', '_blank');
    }

    track = (item) => {
        window.open('https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=' + item.trackingNumber, '_blank');
    }

    pack = (item) => {
        this.props.navigate('/package-slip/po/' + item.id);
    }

    ship = (item) => {
        this.setState({ showTrackingNumber: true, selectedItem: item });
    }

    doShip = (item, trackingNumber) => {
        qreq.post('/api/purchase-order/ship', { ...item, trackingNumber: trackingNumber }, j => {
            if (j.errorCode === 0) {
                this.success('Purchase order shipped.');
                item.shipped = true;
                this.setState({ list: this.state.list });
                this.load();
                this.setState({ currentItem: null });
            }
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    exportList = () => {
        window.open(Globals.serverUrl + '/api/purchase-order/list/export', '_blank');
    }

    deletePO = (item) => {
        Pop.showConfirm(<div>Are you sure you want to delete this purchase order <strong>{item.iid}</strong>?</div>, 'Delete Purchase Order', async () => {
            try {
                let j = await qreq.postAsync('/api/purchase-order/delete', { id: item.id });
                if (j.errorCode === 0) {
                    this.success('Purchase order deleted.');
                    this.load();
                    this.setState({ currentItem: null });
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    placeOnHoldPO = (item) => {
        Pop.showConfirm(<div>Are you sure you want to place this purchase order on hold?</div>, 'Place Purchase Order on Hold', async () => {
            try {
                let j = await qreq.postAsync('/api/purchase-order/hold', { id: item.id, onHold: true });
                if (j.errorCode === 0) {
                    this.success('Purchase order placed on hold.');
                    this.load();
                    this.setState({ currentItem: null });
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    releaseOnHoldPO = (item) => {
        Pop.showConfirm(<div>Are you sure you want to release this purchase order from hold?</div>, 'Release Purchase Order from Hold', async () => {
            try {
                let j = await qreq.postAsync('/api/purchase-order/hold', { id: item.id, onHold: false });
                if (j.errorCode === 0) {
                    this.success('Purchase order released from hold.');
                    this.load();
                    this.setState({ currentItem: null });
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    rollbackPO = (item) => {
        Pop.showConfirm(<div>Are you sure you want to rollback this purchase order?</div>, 'Rollback Purchase Order', async () => {
            try {
                let j = await qreq.postAsync('/api/purchase-order/rollback', { id: item.id });
                if (j.errorCode === 0) {
                    this.success('Purchase order rolled back.');
                    this.load();
                    this.setState({ currentItem: null });
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    showDeliver = (item) => {
        this.setState({ showDeliver: true });
    }

    deliver = async () => {
        try {
            let j = await qreq.postAsync('/api/purchase-order/deliver', this.state.currentItem);
            if (j.errorCode === 0) {
                this.success('Purchase order marked as delivered.');
                this.setState({ currentItem: null, showDeliver: false });
                this.load();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    search = (v) => {
        this.setState({ end: false });
        this.load(v, 1);
    }

    scroll = () => {
        if (!this.state.end)
            this.load(this.state.search, this.state.page + 1);
    }

    render() {

        if (!this.props.com) {
            SidebarGlobal.setSubNav(<><div className="btn-group">
                <Link to="/purchase-order/new" className="btn btn-primary">
                    <FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline">New Purchase Order</span>
                </Link>
                <button type="button" className={'btn btn-secondary' + (this.state.loading ? ' highlighted' : '')} onClick={() => this.load()}>
                    <Icon icon="faRefresh" className={this.state.loading ? 'spinner' : ''} /> <span className="d-none d-md-inline">Refresh</span>
                </button>
                {Auth.hasRole('admin') && <button type="button" onClick={this.exportList} className="btn btn-secondary">
                    <Icon icon="faFileCsv" /> <span className="d-none d-md-inline">Export</span>
                </button>}
            </div></>);
        }


        const header = (<h1>Purchase Orders</h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        return <div className={this.props.com ? '' : 'container-fluid'}>
            {!this.props.com && header}

            <ShipTrackingNumber
                show={this.state.showTrackingNumber}
                defaultTrackingNumber={this.state.selectedItem?.trackingNumber}
                onHide={() => this.setState({ showTrackingNumber: false })}
                onSubmit={(trackingNumber) => this.doShip(this.state.selectedItem, trackingNumber)}
            />

            <DeliverModal
                show={this.state.showDeliver}
                onHide={() => this.setState({ showDeliver: false })}
                onSubmit={() => this.deliver()}
                currentItem={this.state.currentItem}
            />
            <Checkout2Modal
                show={this.state.showCheckout}
                onHide={() => this.setState({ showCheckout: false })}
                currentItem={this.state.checkoutItem}
                onSuccess={this.state.checkoutCallback}
            />

            <Modal show={this.state.currentItem} onHide={() => this.setState({ currentItem: null })}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.currentItem?.iid}</Modal.Title>
                </Modal.Header>
                {this.state.currentItem && <Modal.Body>
                    <div className="d-grid gap-1">
                        {!this.state.currentItem.sent ? <Link title="View PO" to={'/purchase-order/edit/' + this.state.currentItem.id} className="btn btn-primary">
                            <Icon icon="faEdit" /> Edit Purchase Order
                        </Link> : <Link title="View PO" to={'/purchase-order/edit/' + this.state.currentItem.id} className="btn btn-secondary">
                            <Icon icon="faEye" /> View Purchase Order
                        </Link>}
                        {this.state.currentItem.confirmed
                            && <span title="Purchase Order PDF" role="button" className="btn btn-primary" onClick={() => this.downloadPDF(this.state.currentItem.id, this.state.currentItem.iid)}>
                                <Icon icon="faFilePdf" /> Purchase Order PDF
                            </span>}
                        {!Auth.hasRole('manager') && this.state.currentItem.readyToShip && <span title="Packing Slip" role="button" className="btn btn-primary" onClick={() => this.pack(this.state.currentItem)}>
                            <Icon icon="faBox" /> Packing Slip
                        </span>}
                        {this.state.currentItem.trackingNumber && !this.state.currentItem.completed
                            && <span title="Track" role="button" className="btn btn-primary" onClick={() => this.track(this.state.currentItem)}>
                                <Icon icon="faLocationCrosshairs" />
                                Track
                            </span>}
                        {Auth.hasRole('manager') && this.state.currentItem.readyToShip && !this.state.currentItem.shipped && <span title="Ship" role="button" className="btn btn-success" onClick={() => this.ship(this.state.currentItem)}>
                            <Icon icon="faPlane" /> Ship
                        </span>}
                        {Auth.hasRole('manager') && (this.state.currentItem.readyToShip || this.state.currentItem.packaged || this.state.currentItem.shipped || this.state.currentItem.completed) && !this.state.currentItem.invoiceID && !this.state.currentItem.isDonation && <span title="Create Invoice" onClick={() => this.createInvoice(this.state.currentItem)} role="button" className="btn btn-success">
                            <Icon icon="faFileInvoice" /> Create Invoice
                        </span>}
                        {Auth.hasRole('manager') && this.state.currentItem.confirmed && !this.state.currentItem.packaged && <span title="Packing Slip" role="button" className="btn btn-primary" onClick={() => this.pack(this.state.currentItem)}>
                            <Icon icon="faBox" /> Packing Slip
                        </span>}
                        {Auth.hasRole('manager') && this.state.currentItem.sent && this.state.currentItem.shipped && !this.state.currentItem.completed && <span title="Mark as Delivered" role="button" className="btn btn-primary" onClick={() => this.showDeliver(this.state.currentItem)}>
                            <Icon icon="faTruck" /> Mark as Delivered
                        </span>}
                        {Auth.hasRole('manager') && this.state.currentItem.sent && !this.state.currentItem.shipped && !this.state.currentItem.onHold && <span title="Place on Hold" role="button" className="btn btn-warning" onClick={() => this.placeOnHoldPO(this.state.currentItem)}>
                            <Icon icon="faPause" /> Place on Hold
                        </span>}
                        {Auth.hasRole('manager') && this.state.currentItem.sent && !this.state.currentItem.shipped && this.state.currentItem.onHold && <span title="Place on Hold" role="button" className="btn btn-success" onClick={() => this.releaseOnHoldPO(this.state.currentItem)}>
                            <Icon icon="faPlay" /> Release from On Hold
                        </span>}
                        {Auth.hasRole('admin') && this.state.currentItem.sent && !this.state.currentItem.businessApproved && !this.state.currentItem.distributionApproved && <span title="Rollback" role="button" className="btn btn-secondary" onClick={() => this.rollbackPO(this.state.currentItem)}>
                            <Icon icon="faArrowLeft" /> Rollback
                        </span>}
                        {Auth.hasRole('admin') && <span title="Delete" role="button" className="btn btn-danger" onClick={() => this.deletePO(this.state.currentItem)}>
                            <Icon icon="faTrash" /> Delete
                        </span>}
                        <span title="Close" role="button" className="btn btn-secondary" onClick={() => this.setState({ currentItem: null })}>
                            <Icon icon="faTimes" /> Close
                        </span>
                    </div>
                </Modal.Body>}
            </Modal>

            <FormInput
                model={this.state.query}
                name="search"
                label="Search purchase orders..."
                onChange={this.search}
                labelAsPlaceholder
            />

            <table className="table table-striped">
                <thead>
                    <tr>
                        <th></th>
                        <th>PO</th>
                        <th className="d-none d-md-table-cell">Order Date</th>
                        {Auth.hasRole('distributor') && <th className="d-none d-md-table-cell">Bill To</th>}
                        <th className="d-none d-md-table-cell">Ship To</th>
                        {Auth.hasRole('manager') && <th className="d-none d-md-table-cell">Submitted By</th>}
                        {Auth.hasRole('manager') && <th className="d-none d-md-table-cell">Submitted Date</th>}
                    </tr>
                </thead>
                <tbody>
                    {this.state.list.map((item, idx) => <tr key={idx}>
                        <td>
                            {!item.sent ? <Link title="View PO" to={'/purchase-order/edit/' + item.id} className="btn btn-primary">
                                <Icon icon="faEdit" />
                            </Link> : <Link title="View PO" to={'/purchase-order/edit/' + item.id} className="btn btn-secondary">
                                <Icon icon="faEye" />
                            </Link>}
                            <button title="Actions" className="btn btn-secondary" onClick={() => this.setState({ currentItem: item })}>
                                &nbsp;<Icon icon="faEllipsisV" />&nbsp;
                            </button>
                            {!item.sent && <button className="btn btn-success" onClick={(e) => this.sendPO(item, e)}>
                                <Icon icon="faPaperPlane" />
                            </button>}
                        </td>
                        <td>
                            <Link to={'/purchase-order/edit/' + item.id}>
                                {item.iid}<br />{PurchaseOrderGlobal.getStatus(item, this.sendPO)}
                            </Link>
                        </td>
                        <td className="d-none d-md-table-cell">
                            {Globals.toMDYDateString(item.poDate)}
                        </td>
                        {Auth.hasRole('distributor') && <td className="d-none d-md-table-cell">
                            <Link title="View Billing Account" to={'/account/' + item.accountID}><Icon icon="faFileInvoiceDollar" /> {item.accountName}</Link>
                        </td>}
                        <td className="d-none d-md-table-cell">
                            <Link title="View Shipping Account" to={'/account/' + item.shipToAccountID}><Icon icon="faTruckFast" /> {item.shipToAccountName}</Link>
                        </td>
                        {Auth.hasRole('manager') && <td className="d-none d-md-table-cell">
                            {item.sentByUserName || 'N/A'}
                        </td>}
                        {Auth.hasRole('manager') && <td className="d-none d-md-table-cell">
                            {Globals.toMDYHMLocalDateString(item.sentDate)}
                        </td>}
                    </tr>)}
                </tbody>
            </table>
            <ScrollHandler onScroll={this.scroll} />
            {this.state.page > 1 && this.state.loading && <Alert><L>Loading more...</L></Alert>}

        </div>;
    }
}

export default withParamsAndNavigate(PurchaseOrders);